export default phoneNumber => {
  const suffixIndex = phoneNumber.search(/[A-Za-z]/);

  if (suffixIndex === -1) return phoneNumber;

  return phoneNumber.slice(0, suffixIndex);
};
